<div class="container">
  <div class="row center">
    <div class="col col-50 white">
      <app-spinner
        [display]="true"
        [class]="'spinner-container'"
        [messageToDisplay]="'Fetching user data...'"
      ></app-spinner>
    </div>
  </div>
</div>
